import React from "react";
const SaveSearchButton = ({ onSave, className }) => (
  <span tabIndex={0} role="button" onClick={onSave} className={className}>
    <span>{"Spremi"}</span>
  </span>
);

export default SaveSearchButton;



// WEBPACK FOOTER //
// ./src/containers/SearchPage/SearchSection/SaveSearchButton/SaveSearchButton.tsx